import React from "react";

export default function Compliance() {
    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-4">Customer Duty Compliance</h2>

            <p className="mb-4">
                There have been some regulatory changes introduced by the Financial Conduct Authority (FCA),
                specifically the Consumer Duty, which came into effect on 31 July 2023. As a responsible and compliant company,
                we are committed to ensuring that our customers’ best interests are at the heart of everything we do.
            </p>

            <p className="mb-4">
                The FCA Consumer Duty introduces new obligations to enhance consumer protection and ensure fair treatment.
                As a result, we want to assure you that we are taking proactive steps to align our practices with these new requirements.
                Our commitment is to treat all our customers fairly and transparently, providing clear and accurate information
                that enables you to make informed decisions.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Key Principles of the FCA Consumer Duty</h3>
            <p className="mb-4">
                <strong>1. Acting in the customer's best interest:</strong>
                We will act honestly, fairly, and professionally in your best interests.
            </p>
            <p className="mb-4">
                <strong>2. Providing communications that are clear, fair, and not misleading:</strong>
                We will ensure that our communications are clear, concise, and easy to understand,
                allowing you to make well-informed decisions.
            </p>
            <p className="mb-4">
                <strong>3. Managing conflicts of interest:</strong>
                We will manage any potential conflicts of interest to prioritize your needs and interests.
            </p>
            <p className="mb-4">
                <strong>4. Acting fairly and proportionately when resolving disputes:</strong>
                In the event of any disputes, we will handle them in a fair and timely manner,
                ensuring a balanced resolution process.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Our Commitment to You</h3>
            <ul className="list-disc ml-6 mb-6 text-slate-700 space-y-2">
                <li>We will provide you with transparent and comprehensive information about our products and services.</li>
                <li>We will work diligently to ensure that any advice or recommendations we provide are aligned with your individual circumstances and needs.</li>
                <li>We are dedicated to addressing any concerns or complaints you may have in a timely and impartial manner.</li>
            </ul>

            <p>
                If you have any questions relating to Clayton Car Contract’s Consumer Duty Compliance,
                please contact us via telephone son <strong>01785 716133</strong> or email
                <a href="mailto:claytoncontracts@gmail.com" className="text-blue-600 underline ml-1">
                    claytoncontracts@gmail.com
                </a>.
            </p>
        </main>
    );
}
